"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPropertiesInput = setPropertiesInput;
exports.calculateDensity = calculateDensity;
function setPropertiesInput(pvs) {
    return {
        type: "humidity-conversion/SET-PROPERTIES-INPUT",
        payload: pvs
    };
}
function calculateDensity() {
    return {
        type: "humidity-conversion/CALCULATE-DENSITY"
    };
}
//# sourceMappingURL=actions.js.map